import { IActiveIngestion } from '../../redux/ingestion.interface';
import { INGESTION_BY_TABLE_TEXT } from '../IngestionStandaloneDropdown/IngestionByDataSource/IngestionByDataSource.constants';
import { INGESTION_CONSTANTS } from './Ingestion.constants';

export const getTooltipTextForTables = (
  allowIngestionByTable: boolean,
  isFullIngestionActive: boolean,
  isStopping: boolean,
  isLoadingFullIngestionStatus: boolean,
  activeIngestion: IActiveIngestion | null
) => {
  if (isLoadingFullIngestionStatus) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.fullRunningLoading;
  }

  if (isStopping) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.fullStoppingTable;
  }

  if (isFullIngestionActive) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.fullRunningTable;
  }

  if (activeIngestion?.status === INGESTION_CONSTANTS.TRIGGERED_STOP) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.dsStopping;
  }

  if (
    activeIngestion?.status === INGESTION_CONSTANTS.RUNNING &&
    Object.keys(activeIngestion?.tables).length === 0
  ) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.dsRunning;
  }

  if (allowIngestionByTable) {
    return INGESTION_BY_TABLE_TEXT.tooltips.startTable;
  } else {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.ds;
  }
};
